<template>
  <div>
    <div class="imgBtn" @click="togglePortal">
      <img
        style="width:24px;height:24px"
        :src="require(`@/assets/icon/${
          aCameraOn ? 'icCameraStatusOn' : 'icCameraStatusOff'}.png`)"
        alt
      />
      <p style="color:#ffffff">Camera</p>
    </div>
    <div class="box-wrapper" v-if="isPortalOpen">
      <div class="box">
        <div class="header">
          <span style="position: relative;">Camera Sensor</span>
          <div class="swal2-close" @click="togglePortal">×</div>
        </div>

        <div class="inner">
          <div class="text">
            Camera sensor module
          </div>
          <div class="buttonContainer">
            <button
              :class="{ button: true, on: !aCameraOn, off: aCameraOn }"
              :disabled="!canStart"
              @click="toggleCamera"
            >
              <img
                style="width:51px;height:21px"
                :src="
                  require(`@/assets/icon/${aCameraOn ? 'icCameraBtnOff' : 'icCameraBtnOn'}.png`)
                "
                alt=""
              />
            </button>
          </div>
        </div>

        <div class="deviceList">
          <ul>
            <li
              v-for="(camera, index) in cameraSourceWithWifi"
              class="connected-device"
              :key="index"
              @click="clickCamera(camera)"
            >
              {{ camera.label }}
              <span v-if="camera.label === selectedCamera.label" class="checkmark"></span>
            </li>
            <li
              v-for="index in emptyDevices"
              class="connected-device"
              :key="'supplement' + index"
            ></li>
          </ul>
        </div>

        <div class="footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      isPortalOpen: false,
      canStart: false,

      imgTemp: null,
    };
  },
  watch: {
    isWifiCameraOn(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.stopVideo();
      }
    },
  },
  mounted() {
    console.log(Object.keys(this.selectedCamera), !!this.selectedCamera.label);
    if (!this.wifiPlayer) {
      this.setWifiPlayer();
    }
    if (this.selectedCamera.label) {
      this.canStart = true;
    } else {
      console.log('nudefined');
      this.canStart = false;
    }
    if (this.aCameraOn) {
      this.startVideo();
    }
  },
  computed: {
    ...mapState(['cameraRef', 'wifiCameraRef', 'isCameraOn', 'isWifiCameraOn', 'selectedCamera', 'wifiPlayer']),
    ...mapGetters(['cameraSourceWithWifi']),
    emptyDevices() {
      return 4 - this.cameraSourceWithWifi.length;
    },
    aCameraOn() {
      return this.isCameraOn || this.isWifiCameraOn;
    },
  },
  methods: {
    ...mapMutations(['selectCamera', 'changeCamerStatus', 'setWifiPlayer']),
    togglePortal() {
      this.isPortalOpen = !this.isPortalOpen;
    },
    clickCamera(camera) {
      console.log(camera);
      this.canStart = true;
      this.selectCamera(camera);
      if (this.aCameraOn) {
        this.startVideo();
      }
    },
    stopVideo() {
      // camera
      if (this.cameraRef.srcObject !== null) {
        this.cameraRef.srcObject.getTracks().forEach((track) => {
          track.stop();
        });
      }
      this.cameraRef.srcObject = null;
      console.log(this.cameraRef.srcObject);
      this.cameraRef.load();

      // wifi cam
      this.wifiPlayer.stop();
      this.$emit('stopVideo');
    },
    startVideo() {
      this.stopVideo();
      if (this.selectedCamera.label === 'FR WifiCam') {
        this.changeCamerStatus({
          isCameraOn: false,
          isWifiCameraOn: true,
        });
        this.wifiPlayer.start();
      } else {
        this.changeCamerStatus({
          isCameraOn: true,
          isWifiCameraOn: false,
        });
        const constraint = { video: { deviceId: this.selectedCamera.device.deviceId } };
        navigator.mediaDevices.getUserMedia(constraint).then((stream) => {
          this.cameraRef.srcObject = stream;
        });
      }
    },
    toggleCamera() {
      if (this.aCameraOn) {
        this.changeCamerStatus({
          isCameraOn: false,
          isWifiCameraOn: false,
        });
        this.stopVideo();
      } else {
        console.log(this.selectedCamera);
        this.startVideo();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div,
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.imgBtn {
  display: flex;
  line-height: 24px;
  align-items: center;
  p {
    margin: 0 6px;
    line-height: 35px;
  }
}
.box-wrapper {
  z-index: 1000;
  font-family: Arial;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.box {
  width: 400px;
  position: relative;
}

.header {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  background-color: white;
  color: black;
  height: 35px;
  line-height: 35px;
  display: flex;
  justify-content: center;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 14px;
  box-shadow: 0.2px 0.2px 4px 1px rgba(0, 0, 0, 0.1);
  width: 400px;
}
.swal2-close {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  -webkit-box-pack: center;
  justify-content: center;

  padding: 0;
  overflow: hidden;
  -webkit-transition: color 0.1s ease-out;
  transition: color 0.1s ease-out;
  border: none;
  border-radius: 0;
  outline: initial;
  background: 0 0;
  color: #ccc;
  font-family: serif;
  font-size: 2.5em;

  cursor: pointer;
  height: 35px;
  width: 35px;
  line-height: 35px;
  &:hover {
    color: #39e2cf;
  }
}

.inner {
  background-color: #f3f5f9;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
  .text {
    text-align: left;
    font-size: 15px;
    padding: 15px;
    color: black;
    width: 70%;
  }
  .buttonContainer {
    display: flex;
    margin-right: 9px;
    padding: 0px 9px;
    button {
      padding: 0;
      width: 74px;
      height: 30px;
      border-radius: 15px;
      display: flex;
      border: none;
      &:disabled {
        cursor: not-allowed;
      }
      img {
        margin: auto;
      }
    }
    .on {
      background-color: #37ccda;
    }
    .off {
      background-color: #727374;
    }
  }
}

.deviceList {
  background-color: #fff;
  margin: 0px;
}
.connected-device {
  color: black;
  padding: 0 17px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #37ccda;
  text-align: left;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #37ccda;
    color: white;
  }
  .deviceState {
    float: right;
  }
  .checkmark {
    height: 17px;
    width: 11px;
    right: 12px;
    top: 50%;
    border-bottom: 3px solid #37ccda;
    border-right: 3px solid #37ccda;
    transform: translateY(-50%) rotate(45deg);
    display: inline-block;
    position: absolute;
  }

  &:hover {
    .checkmark {
      border-bottom: 3px solid #fff;
      border-right: 3px solid #fff;
    }
  }
}
.footer {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #f3f5f9;
  padding: 16px 0;
}
</style>
